/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PortalConfigsMinimal } from '../models/PortalConfigsMinimal';
import { request as __request } from '../core/request';

export class PortalVService {

    /**
     * @param url
     * @param kiosk
     * @returns PortalConfigsMinimal OK
     * @throws ApiError
     */
    public static async portalVGetOperatorConfigs(
        url?: string,
        kiosk?: string,
    ): Promise<PortalConfigsMinimal> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/Operators/Portal`,
            query: {
                'url': url,
                'kiosk': kiosk,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}